import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { VolatilityProfile } from '../../types/entities';

import { initialState, VolatilityProfileState } from './state';

const volatilityProfileSlice = createSlice({
  name: 'volatility-profile',
  initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: VolatilityProfileState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    success: (state: VolatilityProfileState, action: PayloadAction<VolatilityProfile[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.profiles = action.payload;
    },
    fail: (state: VolatilityProfileState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.profiles = [];
    },
    add: (state: VolatilityProfileState, action: PayloadAction<VolatilityProfile>) => {
      state.profiles.push(action.payload);
      state.loading = false;
      state.loaded = true;
    },
    update: (state: VolatilityProfileState, action: PayloadAction<VolatilityProfile>) => {
      const dbEntry = state.profiles.find((x) => x.id === action.payload.id);
      if (!!dbEntry) {
        const index = state.profiles.indexOf(dbEntry);
        state.profiles[index] = action.payload;
      }
      state.loading = false;
      state.loaded = true;
    },
    remove: (state: VolatilityProfileState, action: PayloadAction<VolatilityProfile>) => {
      const entry = state.profiles.find((x) => x.id === action.payload.id);
      const index = entry ? state.profiles.indexOf(entry) : -1;
      if (index !== -1) {
        state.profiles.splice(index, 1);
      }
      state.loading = false;
      state.loaded = true;
    }
  }
});

const { actions, reducer } = volatilityProfileSlice;
export const { reset, loading, success, fail, add, update, remove } = actions;
export default reducer;
